<template>
  <v-dialog
    width="700"
    persistent
    :fullscreen="isMobile"
    :model-value="modelValue"
    @update:model-value="onUpdate"
  >
    <div class="popup">
      <div class="popup-header">
        <h3 class="popup-title">
          {{ title }}
        </h3>

        <button class="popup-close" @click="handleClose">
          <v-icon :size="32">mdi-close</v-icon>
        </button>
      </div>

      <div class="popup-content">
        <slot name="content"></slot>
      </div>

      <div class="popup-actions">
        <gs-button
          :disabled="loading"
          :loading="loading"
          full-width
          size="large"
          type="primary"
          @click="primaryButtonAction"
        >
          {{ primaryButtonText }}
        </gs-button>
        <gs-button
          v-if="secondaryButtonText"
          :disabled="loading"
          :loading="loading"
          class="mt-2"
          full-width
          type="info"
          size="large"
          @click="secondaryButtonAction"
        >
          {{ secondaryButtonText }}
        </gs-button>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { Utils } from '@/helpers/mixins/utilsMixin'

export default defineComponent({
  name: 'BasePopup',
  mixins: [Utils],
  emits: ['update:model-value', 'submit'],
  created() {
    window.addEventListener('resize', this.reportWindowSize)
    this.reportWindowSize()
  },
  unmounted() {
    window.removeEventListener('resize', this.reportWindowSize)
  },
  methods: {
    onUpdate(e: boolean) {
      this.$emit('update:model-value', e)
    },
    handleClose() {
      this.$emit('update:model-value', false)
    },
    handleSubmit() {
      this.$emit('submit')
    },
  },
  props: {
    modelValue: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    primaryButtonText: {
      type: String,
    },
    primaryButtonAction: {
      type: Function as PropType<() => void>,
    },
    secondaryButtonText: {
      type: String,
    },
    secondaryButtonAction: {
      type: Function as PropType<() => void>,
    },
    loading: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '~vuetify/settings';

.popup {
  background: white;
  padding: 24px;
  border-radius: var(--border-radius-big) !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.popup-title {
  font-size: 32px;
  line-height: 39px;
  font-weight: bold;
}

.popup-content {
  font-size: 18px;
  margin-top: 32px;
}

.popup-actions {
  margin-top: 32px;
}
</style>
